(() => {
  if (customElements.get('sticky-atc-bar')) return;

  class StickyAtcBar extends HTMLElement {
    connectedCallback() {
      this.bar = this.closest('[data-sticky-atc-bar]');
      this.form = this.dataset.formId ? document.getElementById(this.dataset.formId) : document.querySelector('.main-product .js-main-product-form');
      this.sourceSection = this.dataset.sourceSectionId ? document.getElementById(this.dataset.sourceSectionId) : this.form?.closest('.main-product');
      this.priceSource = this.dataset.priceId ? document.getElementById(this.dataset.priceId) : this.sourceSection?.querySelector('[id^="productPrice-"]');
      this.button = this.querySelector('[data-sticky-atc-submit]');
      this.buttonLabel = this.querySelector('[data-sticky-atc-label]');
      this.price = this.querySelector('[data-sticky-atc-price]');
      this.variant = this.querySelector('[data-sticky-atc-variant]');
      this.variantInputs = Array.from(this.querySelectorAll('[data-sticky-atc-variant-input]'));
      this.quantityInputs = Array.from(this.querySelectorAll('[data-sticky-atc-quantity-input]'));
      this.acceleratedForm = this.querySelector('.sticky-atc-bar__accelerated-form');
      this.primaryButton = this.form?.querySelector('.js-product-form-submit-btn');

      if (!this.bar || !this.form || !this.sourceSection || !this.primaryButton || !this.button) {
        this.bar?.remove();
        return;
      }

      this.handleClick = this.handleClick.bind(this);
      this.handleDocumentChange = this.handleDocumentChange.bind(this);
      this.handleVisibility = this.handleVisibility.bind(this);
      this.sync = this.sync.bind(this);

      this.button.addEventListener('click', this.handleClick);
      document.addEventListener('change', this.handleDocumentChange);
      this.form.addEventListener('input', this.sync);

      this.visibilityObserver = new IntersectionObserver(this.handleVisibility, {
        rootMargin: '-12px 0px 0px 0px',
        threshold: 0
      });
      this.visibilityObserver.observe(this.primaryButton);

      this.stateObserver = new MutationObserver(this.sync);
      this.stateObserver.observe(this.primaryButton, { attributes: true, childList: true, subtree: true });
      this.priceObserver = new MutationObserver(this.sync);
      this.priceSource && this.priceObserver.observe(this.priceSource, { childList: true, subtree: true });

      this.sync();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleClick);
      document.removeEventListener('change', this.handleDocumentChange);
      this.form?.removeEventListener('input', this.sync);
      this.visibilityObserver?.disconnect();
      this.stateObserver?.disconnect();
      this.priceObserver?.disconnect();
    }

    handleClick() {
      if (!this.button.disabled) this.form.requestSubmit();
    }

    handleDocumentChange(event) {
      if (this.sourceSection.contains(event.target)) this.sync();
    }

    handleVisibility(entries) {
      const entry = entries[0];
      this.bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }

    sync() {
      const idInput = this.form.querySelector('[name="id"]');
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const isAvailable = Boolean(idInput?.value) && !this.primaryButton.disabled;
      const selectedValues = Array.from(this.sourceSection.querySelectorAll('.js-variant-radio-item:checked, .js-variant-select-item')).map((input) => input.value).filter(Boolean);
      const quantity = quantityInput?.value || '1';
      const hasSelectedPlaBundle = Boolean(this.sourceSection.querySelector('[data-pla-toggle]:checked'));

      this.button.disabled = !isAvailable;
      if (this.acceleratedForm) this.acceleratedForm.hidden = !isAvailable || hasSelectedPlaBundle;

      this.variantInputs.forEach((input) => {
        input.disabled = !isAvailable;
        if (idInput && input.value !== idInput.value) {
          input.value = idInput.value;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      this.quantityInputs.forEach((input) => {
        if (input.value !== quantity) {
          input.value = quantity;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      if (this.buttonLabel) this.buttonLabel.textContent = this.primaryButton.querySelector('.js-product-form-submit-btn-text')?.textContent.trim() || this.buttonLabel.textContent;
      if (this.variant && selectedValues.length) this.variant.textContent = selectedValues.join(' / ');
      if (this.priceSource && this.price) this.price.innerHTML = this.priceSource.innerHTML;
    }
  }

  customElements.define('sticky-atc-bar', StickyAtcBar);
})();
